<!-- 
Shows the tabs for the notice template page.
-->
<template>
  <div>
    <our-actions-bar 
      :actions="actions"
      @edit="showEditDialog = true"
      @emailpreview="showEmailDialog = true"
    >
      <our-next-previous-navigator
        :next-page-action="nextPageAction"
        :previous-page-action="previousPageAction"
        :nav-url="navUrl"
        id-field="type"
        module="noticeTemplates"
        class="mb-2"
      />
    </our-actions-bar>
    <v-card class="home">
      <v-tabs slider-color="primary" show-arrows>
        <v-tab key="preview" :to="getUrl('preview')">
          Preview
        </v-tab>
        <v-tab key="details" :to="getUrl('details')">
          Details
        </v-tab>
        <v-tab key="history" :to="getUrl('history')">
          History
        </v-tab>
      </v-tabs>
      <slot/>
    </v-card>
    <notice-template-edit-dialog v-model="showEditDialog" :levy-collection-id="levyCollectionId" :notice-type="noticeType"/>
    <notice-template-email-dialog v-model="showEmailDialog" :levy-collection-id="levyCollectionId" :notice-type="noticeType"/>
  </div>
</template>

<script>
import NoticeTemplateEditDialog from "@/components/notice-templates/NoticeTemplateEditDialog.vue";
import NoticeTemplateEmailDialog from "@/components/notice-templates/NoticeTemplateEmailDialog.vue";
import * as action from "@/store/notice-templates/action-types";

export default {
  components: { NoticeTemplateEmailDialog, NoticeTemplateEditDialog },
  props: {
    levyCollectionId: {
      required: true,
      type: Number
    },
    noticeType: {
      required: true,
      type: String
    },
    path: {
      required: true,
      type: String
    },
    canEdit: {
      required: true,
      type: Boolean
    }
  },
  data() {
    return {
      showEmailDialog: false,
      showEditDialog: false
    };
  },
  computed: {
    actions() {
      const results = [];
      if (this.canEdit)
        results.push({
          icon: "edit",
          text: "Edit",
          emit: "edit",
          description: "Edit the details of this template"
        });
      results.push({
        icon: "email",
        text: "Email me a preview",
        emit: "emailpreview",
        description: "Send me an email of a preview of this template"
      });
      return results;
    },
    nextPageAction() {
      return action.LIST_NEXT_PAGE;
    },
    previousPageAction() {
      return action.LIST_PREVIOUS_PAGE;
    },
    navUrl() {
      return `/levy-collections/${this.levyCollectionId}/setup/notices/:id/${this.path}`;
    }
  },
  methods: {
    getUrl(suffix) {
      return `/levy-collections/${this.levyCollectionId}/setup/notices/${this.noticeType}/${suffix}`;
    }
  }
};
</script>
